export default __webpack_public_path__ + "static/media/024-flag.d34dc9fa.svg";